Object.defineProperty(exports,"__esModule",{value:true});exports.countNonCompliantPositionRules=exports.countAreaStates=exports.positionStatesCounterForFixture=exports.positionStatesCounterForArea=exports.positionStatesCounterForFloor=exports.countIssuesForFixtureWithSplittedAlarming=exports.countIssuesForAreaWithSplittedAlarming=exports.countIssuesForFloorWithSplittedAlarming=exports.numberOfPositionsWithIssueByStore=exports.stateCountersForFixture=exports.stateCountersForArea=exports.summary=undefined;exports.




























































































































































































































































































































































































































































































getIssuesCountHC=getIssuesCountHC;var _helper=require('../sorting/helper');var _types=require('../armState/types');var _securityDeviceHealthStatus=require('../healthStatus/securityDeviceHealthStatus');var _types2=require('../complianceState/types');var _complianceState=require('../complianceState/complianceState');var summary=exports.summary=function summary(fixture,ignoreUnlocked){var positions=fixture.positionIds.toModelArray();var result=positions.reduce(function(totals,position){var _positionStates=(0,_helper.positionStates)(position),armState=_positionStates.armState,healthState=_positionStates.healthState,complianceState=_positionStates.complianceState;var red=(0,_helper.isRed)(armState);var yellow=(0,_helper.isYellow)(healthState,complianceState);var unlocked=ignoreUnlocked?false:(0,_helper.isUnlocked)(armState);if(red){totals.red+=1;}if(yellow){totals.yellow+=1;}if(unlocked){totals.yellow+=1;}if(!red&&!yellow&&!unlocked){totals.ok+=1;}return totals;},{red:0,yellow:0,ok:0});return result;};var stateCountersForArea=exports.stateCountersForArea=function stateCountersForArea(area,ignoreUnlocked){if(!area){return null;}var fixtures=area.fixtureIds.toModelArray();return fixtures.map(function(fixture){return summary(fixture,ignoreUnlocked);}).reduce(function(currentSum,fixtureCounters){return{red:currentSum.red+fixtureCounters.red,yellow:currentSum.yellow+fixtureCounters.yellow,ok:currentSum.ok+fixtureCounters.ok};},{red:0,yellow:0,ok:0});};var stateCountersForFixture=exports.stateCountersForFixture=summary;var numberOfPositionsWithIssueByStore=exports.numberOfPositionsWithIssueByStore=function numberOfPositionsWithIssueByStore(store){if(!store){return{red:0,yellow:0};}var fixtures=[];store.floorIds.toModelArray().map(function(floor){var floorAreas=floor.areaIds.toModelArray();floorAreas.forEach(function(area){var areaFixtures=area.fixtureIds.toModelArray();fixtures=fixtures.concat(areaFixtures);});});return fixtures.map(countIssues).reduce(function(currentSum,fixtureCounters){return{red:currentSum.red+fixtureCounters.red,yellow:currentSum.yellow+fixtureCounters.yellow};},{red:0,yellow:0});};var countIssues=function countIssues(fixture){var positions=fixture.positionIds.toModelArray();var result=positions.reduce(function(totals,position){var _positionStates2=(0,_helper.positionStates)(position),armState=_positionStates2.armState,healthState=_positionStates2.healthState,complianceState=_positionStates2.complianceState;if((0,_helper.isRed)(armState)){totals.red+=1;}else if((0,_helper.isYellow)(healthState,complianceState)||(0,_helper.isUnlocked)(armState)){totals.yellow+=1;}return totals;},{red:0,yellow:0});return result;};var countIssuesForFloorWithSplittedAlarming=exports.countIssuesForFloorWithSplittedAlarming=function countIssuesForFloorWithSplittedAlarming(floor,ignoreUnlocked){if(!floor){return null;}var area=floor.areaIds.toModelArray();return area.map(function(area){return countIssuesForAreaWithSplittedAlarming(area,ignoreUnlocked);}).reduce(function(currentSum,areaCounters){return{alarming:currentSum.alarming+areaCounters.alarming,red:currentSum.red+areaCounters.red,yellow:currentSum.yellow+areaCounters.yellow,ok:currentSum.ok+areaCounters.ok};},{alarming:0,red:0,yellow:0,ok:0});};var countIssuesForAreaWithSplittedAlarming=exports.countIssuesForAreaWithSplittedAlarming=function countIssuesForAreaWithSplittedAlarming(area,ignoreUnlocked){if(!area){return null;}var fixtures=area.fixtureIds.toModelArray();return fixtures.map(function(fixture){return countIssuesForFixtureWithSplittedAlarming(fixture,ignoreUnlocked);}).reduce(function(currentSum,fixtureCounters){return{alarming:currentSum.alarming+fixtureCounters.alarming,red:currentSum.red+fixtureCounters.red,yellow:currentSum.yellow+fixtureCounters.yellow,ok:currentSum.ok+fixtureCounters.ok};},{alarming:0,red:0,yellow:0,ok:0});};var countIssuesForFixtureWithSplittedAlarming=exports.countIssuesForFixtureWithSplittedAlarming=function countIssuesForFixtureWithSplittedAlarming(fixture,ignoreUnlocked){var positions=fixture.positionIds.toModelArray();var result=positions.reduce(function(totals,position){var _positionStates3=(0,_helper.positionStates)(position),armState=_positionStates3.armState,healthState=_positionStates3.healthState,complianceState=_positionStates3.complianceState;var alarming=(0,_helper.isAlarming)(armState);var red=(0,_helper.isDisarmed)(armState);var yellow=(0,_helper.isYellow)(healthState,complianceState);var unlocked=ignoreUnlocked?false:(0,_helper.isUnlocked)(armState);if(alarming){totals.alarming+=1;}if(red){totals.red+=1;}if(yellow){totals.yellow+=1;}if(unlocked){totals.yellow+=1;}if(!alarming&&!red&&!yellow&&!unlocked){totals.ok+=1;}return totals;},{alarming:0,red:0,yellow:0,ok:0});return result;};var positionStatesCounterForFloor=exports.positionStatesCounterForFloor=function positionStatesCounterForFloor(floor){if(!floor){return null;}var areas=floor.areaIds.toModelArray();return areas.map(positionStatesCounterForArea).reduce(function(currentSum,areaCounters){return{alarming:currentSum.alarming+areaCounters.alarming,silentAlarming:currentSum.silentAlarming+areaCounters.silentAlarming,armed:currentSum.armed+areaCounters.armed,disarmed:currentSum.disarmed+areaCounters.disarmed,locked:currentSum.locked+areaCounters.locked,unlocked:currentSum.unlocked+areaCounters.unlocked,otherState:currentSum.otherState+areaCounters.otherState,unknownDevice:currentSum.unknownDevice+areaCounters.unknownDevice,healthy:currentSum.healthy+areaCounters.healthy,unhealthy:currentSum.unhealthy+areaCounters.unhealthy,warning:currentSum.warning+areaCounters.warning,unknown:currentSum.unknown+areaCounters.unknown,missingSecurityDevice:currentSum.missingSecurityDevice+areaCounters.missingSecurityDevice,compliant:currentSum.compliant+areaCounters.compliant,nonCompliant:currentSum.nonCompliant+areaCounters.nonCompliant};},{alarming:0,silentAlarming:0,armed:0,disarmed:0,locked:0,unlocked:0,otherState:0,unknownDevice:0,healthy:0,unhealthy:0,warning:0,unknown:0,missingSecurityDevice:0,compliant:0,nonCompliant:0});};var positionStatesCounterForArea=exports.positionStatesCounterForArea=function positionStatesCounterForArea(area){if(!area){return null;}var fixtures=area.fixtureIds.toModelArray();return fixtures.map(positionStatesCounterForFixture).reduce(function(currentSum,fixtureCounters){return{alarming:currentSum.alarming+fixtureCounters.alarming,silentAlarming:currentSum.silentAlarming+fixtureCounters.silentAlarming,armed:currentSum.armed+fixtureCounters.armed,disarmed:currentSum.disarmed+fixtureCounters.disarmed,locked:currentSum.locked+fixtureCounters.locked,unlocked:currentSum.unlocked+fixtureCounters.unlocked,otherState:currentSum.otherState+fixtureCounters.otherState,unknownDevice:currentSum.unknownDevice+fixtureCounters.unknownDevice,healthy:currentSum.healthy+fixtureCounters.healthy,unhealthy:currentSum.unhealthy+fixtureCounters.unhealthy,warning:currentSum.warning+fixtureCounters.warning,unknown:currentSum.unknown+fixtureCounters.unknown,missingSecurityDevice:currentSum.missingSecurityDevice+fixtureCounters.missingSecurityDevice,compliant:currentSum.compliant+fixtureCounters.compliant,nonCompliant:currentSum.nonCompliant+fixtureCounters.nonCompliant};},{alarming:0,silentAlarming:0,armed:0,disarmed:0,locked:0,unlocked:0,otherState:0,unknownDevice:0,healthy:0,unhealthy:0,warning:0,unknown:0,missingSecurityDevice:0,compliant:0,nonCompliant:0});};var positionStatesCounterForFixture=exports.positionStatesCounterForFixture=function positionStatesCounterForFixture(fixture){var positions=fixture.positionIds.toModelArray();return positions.reduce(function(totals,position){var _positionStates4=(0,_helper.positionStates)(position),armState=_positionStates4.armState,healthState=_positionStates4.healthState,complianceState=_positionStates4.complianceState;if(armState){switch(armState.type){case _types.armState.ALARMING:totals.alarming+=1;break;case _types.armState.SILENT_ALARMING:totals.silentAlarming+=1;break;case _types.armState.DISARMED:totals.disarmed+=1;break;case _types.armState.ARMED:totals.armed+=1;break;case _types.armState.UNLOCKED:totals.unlocked+=1;break;case _types.armState.LOCKED:totals.locked+=1;break;case _types.armState.UNKNOWN_DEVICE:totals.unknownDevice+=1;break;case _types.armState.MISSING_SECURITY_DEVICE:totals.missingSecurityDevice+=1;break;default:totals.otherState+=1;}}switch(healthState.type){case _securityDeviceHealthStatus.HealthStatus.UNHEALTHY:totals.unhealthy+=1;break;case _securityDeviceHealthStatus.HealthStatus.HEALTHY:totals.healthy+=1;break;case _securityDeviceHealthStatus.HealthStatus.WARNING:totals.warning+=1;break;case _securityDeviceHealthStatus.HealthStatus.UNKNOWN:totals.unknown+=1;break;case _securityDeviceHealthStatus.HealthStatus.MISSING_SECURITY_DEVICE:totals.missingSecurityDevice+=1;break;}switch(complianceState.type){case _types2.ComplianceStatus.NON_COMPLIANT:totals.nonCompliant+=1;break;case _types2.ComplianceStatus.COMPLIANT:totals.compliant+=1;break;}return totals;},{alarming:0,silentAlarming:0,armed:0,disarmed:0,locked:0,unlocked:0,otherState:0,unknownDevice:0,healthy:0,unhealthy:0,warning:0,unknown:0,missingSecurityDevice:0,compliant:0,nonCompliant:0});};var countAreaStates=exports.countAreaStates=function countAreaStates(fixturesWithStatesCounted){var count={alarming:0,silentAlarming:0,disarmed:0,unlocked:0,unhealthy:0,nonCompliant:0,armed:0,locked:0,otherState:0,unknownDevice:0,healthy:0,warning:0,unknown:0,missingSecurityDevice:0,compliant:0};if(!fixturesWithStatesCounted||fixturesWithStatesCounted.length<1)return count;return fixturesWithStatesCounted.reduce(function(total,fixture){var _fixture$statesCounte=fixture.statesCounter,alarming=_fixture$statesCounte.alarming,silentAlarming=_fixture$statesCounte.silentAlarming,disarmed=_fixture$statesCounte.disarmed,armed=_fixture$statesCounte.armed,unlocked=_fixture$statesCounte.unlocked,locked=_fixture$statesCounte.locked,otherState=_fixture$statesCounte.otherState,unknownDevice=_fixture$statesCounte.unknownDevice,unhealthy=_fixture$statesCounte.unhealthy,healthy=_fixture$statesCounte.healthy,warning=_fixture$statesCounte.warning,unknown=_fixture$statesCounte.unknown,missingSecurityDevice=_fixture$statesCounte.missingSecurityDevice,compliant=_fixture$statesCounte.compliant,nonCompliant=_fixture$statesCounte.nonCompliant;if(alarming>0)total.alarming+=1;if(silentAlarming>0)total.silentAlarming+=1;if(disarmed>0)total.disarmed+=1;if(unlocked>0)total.unlocked+=1;if(unhealthy>0)total.unhealthy+=1;if(nonCompliant>0)total.nonCompliant+=1;if(armed>0)total.armed+=1;if(locked>0)total.locked+=1;if(otherState>0)total.otherState+=1;if(unknownDevice>0)total.unknownDevice+=1;if(healthy>0)total.healthy+=1;if(warning>0)total.warning+=1;if(unknown>0)total.unknown+=1;if(missingSecurityDevice>0)total.missingSecurityDevice+=1;if(compliant>0)total.compliant+=1;return total;},count);};var countNonCompliantPositionRules=exports.countNonCompliantPositionRules=function countNonCompliantPositionRules(positionModel){if(!positionModel.ruleIds)return 0;var rules=positionModel.ruleIds.toRefArray();return(0,_complianceState.getOutOfComplianceRules)(rules).length;};function getIssuesCountHC(position){var
rules=position.rules,healthStateType=position.status.states.healthStateType;
var complianceIssuesCount=rules.reduce(
function(count,item){return(
item.status===_types2.PositionRuleStatus.VIOLATION?count+1:count);},
0);


var healthIssuesCount=function(){
switch(healthStateType){
case _securityDeviceHealthStatus.HealthStatus.HEALTHY:
return 0;
case _securityDeviceHealthStatus.HealthStatus.UNHEALTHY:
case _securityDeviceHealthStatus.HealthStatus.WARNING:
case _securityDeviceHealthStatus.HealthStatus.MISSING_SECURITY_DEVICE:
case _securityDeviceHealthStatus.HealthStatus.UNKNOWN:
return 1;
default:
return 0;}

}();

return complianceIssuesCount+healthIssuesCount;
}